"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ensureInputs = void 0;
function ensureInputs(inputs) {
    if (!inputs) {
        throw new Error("inputs is undefined"); // should never happen
    }
    return inputs;
}
exports.ensureInputs = ensureInputs;
//# sourceMappingURL=utils.js.map